import type { ExtractInjectionAPI } from '@atlaskit/editor-common/types';

import type { MalleableUiPlugin } from '../malleableUiPluginType';

/**
 * The persistent mount point for machine-driven editor Remix effects. Inert for now: renders
 * `null`, holds no state, reads nothing, registers nothing.
 *
 * A sibling of `RemixContent` rather than a descendant, because `RemixContentComponent` renders
 * nothing once the modal, thinking UI and location picker are down — a subscription mounted in
 * there would be dropped by terminal cleanup along with every command that follows it.
 *
 * Reads no gate or experiment itself. The mount in `malleableUiPlugin` already requires the
 * `remix_state_rearchitecture_enabled` master gate and an exposure-free read of the
 * `remix_state_rearchitecture_editor` cohort, so this component only ever renders where the
 * migration is live. Hooks mounted here keep their own admitted-session checks.
 *
 * `api` is unused until those hooks arrive, but is part of the contract now so they need not reopen
 * `malleableUiPlugin.tsx` to thread it through.
 */
export const EditorRemixEffectHost = (_props: {
	api: ExtractInjectionAPI<MalleableUiPlugin> | undefined;
}): null => null;
